// Generated by scripts/build-ui-icons.mjs.
export { ChatCircle as default } from "../ui/glyphs-2";
